import { ListContentsItem } from "@contentchef/contentchef-types";
import { List } from "antd";
import { inject, observer } from "mobx-react";
import React, { Component } from "react";
import { defineMessages, injectIntl } from "react-intl";
import { Link, RouteComponentProps } from "react-router-dom";
import {
  ContainerWithAside,
  ContentItem,
  ContentListFilters,
  ContentsFooter,
  FloatingActions,
} from "../../../components";
import AddButton from "../../../components/atoms/AddButton";
import { contentSelectDefinitionPath, editContentPath } from "../../../constants/routing-constants";
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from "../../../constants/tables";
import { userPermissionsTable } from "../../../constants/user-permissions-table";
import { withContentsStores, WithLoadingData } from "../../../hoc";
import { HasPermissions } from "../../../providers/UserPermissionsProvider";
import { ContentListUrlParams } from "../../../stores/contentListStore/contentListStoreModel";
import styles from "./ContentList.module.scss";
import { ContentListProps, ContentListState, InjectedProps } from "./ContentListModel";

const labels = defineMessages({
  buttonTitle: {
    id: "Content.Add",
    defaultMessage: "Add new content",
  },
});

@inject("contentListStore", "contentListFiltersStore")
@observer
class ContentList extends Component<ContentListProps, ContentListState> {
  get injected() {
    return this.props as InjectedProps;
  }

  getContentList = (prevProps: RouteComponentProps) => {
    if (prevProps && prevProps.location.search.length > 0 && this.props.location.search.length === 0) {
      this.injected.contentListStore.searchParams.reset();
    }
    return this.injected.contentListStore.initContentList();
  };

  printCreateButton = () => {
    const {
      match: {
        params: { spaceId },
      },
    } = this.props;
    return (
      <Link to={contentSelectDefinitionPath(spaceId)}>
        <AddButton dataId="btn-create-content" title={labels.buttonTitle} />
      </Link>
    );
  };

  render() {
    const { dataAttributes } = this.props;
    const { spaceId } = this.props.match.params;
    const { usableSearchParams = {}, urlSearchParams } = this.injected.contentListStore.searchParams;
    return (
      <React.Fragment>
        <ContainerWithAside
          drawerIcon={"filter"}
          dataAttributes={dataAttributes}
          footer={
            <ContentsFooter
              currentSize={
                urlSearchParams.has(ContentListUrlParams.bySize)
                  ? parseInt(usableSearchParams[ContentListUrlParams.bySize], undefined)
                  : DEFAULT_PAGE_SIZE
              }
              currentPage={
                urlSearchParams.has(ContentListUrlParams.byPage)
                  ? parseInt(usableSearchParams[ContentListUrlParams.byPage], undefined)
                  : DEFAULT_PAGE
              }
            />
          }
          renderAside={() => <ContentListFilters />}
        >
          <WithLoadingData promise={this.getContentList} rerenderWhenRouteChange={true}>
            <List
              className={styles.ContentListContainer}
              itemLayout="horizontal"
              dataSource={this.injected.contentListStore.contentListData.contentsByRepo}
              renderItem={(item: ListContentsItem) => (
                <ContentItem content={item} linkTo={editContentPath(spaceId, item.id)} showActions={true} />
              )}
            />
          </WithLoadingData>
        </ContainerWithAside>
        <HasPermissions permissions={userPermissionsTable.FloatingActions.Content}>
          <FloatingActions>{this.printCreateButton()}</FloatingActions>
        </HasPermissions>
      </React.Fragment>
    );
  }
}

export default withContentsStores(injectIntl(ContentList));
